const grandfather = `Tärkeä ihminen elämässäni on isoisäni.
Hän on minulle tärkeä, koska hän on aina ollut horjumattoman tuen ja ohjauksen lähde.
Hän on myötätuntoinen ja viisas yksilö, jolla on runsaasti elämänkokemusta, jonka hän jakaa avokätisesti kanssani.
Hän on ollut voimanpylväs niin kauan kuin muistan, tarjoten korvaamattomia neuvoja ja rohkaisua niin haastavina kuin iloisinakin hetkinä.
Parasta isoisässäni on hänen kykynsä kuunnella tuomitsematta ja tarjota oivaltavia näkökulmia, jotka ovat auttaneet muotoilemaan luonnettani ja arvojani.
Vietämme usein aikaa yhdessä, keskustelemme elämän eri puolista, jaamme tarinoita ja nautimme toistemme seurasta.
Häneltä haluaisin oppia kärsivällisyyden taitoa ja empatian hyvettä,
josta hän on vaivattomasti esimerkkinä vuorovaikutuksessaan muiden kanssa.`;

export default grandfather;